// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ex-j";
export var fulfillmentFormRail = "_ex-i";
export var headerTitleRow = "_ex-l";
export var orderDetailsWrapper = "_ex-g";
export var orderLinkTrigger = "_ex-2";
export var paymentInformationGrid = "_ex-q";
export var paymentSummaryColumn = "_ex-r";
export var phoneShipmentPickerButton = "_ex-e";
export var phoneShipmentPickerButtonContent = "_ex-f";
export var phoneShipmentPickerButtonWrapper = "_ex-d";
export var phoneShipmentPickerTrigger = "_ex-c";
export var shipmentContainer = "_ex-k";
export var shipmentDetailsMainPane = "_ex-h";
export var shipmentNavigationCard = "_ex-a";
export var shipmentNavigationEdgeTrigger = "_ex-6";
export var shipmentNavigationRail = "_ex-3";
export var shipmentNavigationRailEnter = "_ex-5";
export var shipmentNavigationRailHeader = "_ex-9";
export var shipmentNavigationRailOverlay = "_ex-4";
export var shipmentNavigationScrim = "_ex-7";
export var shipmentSummaryFact = "_ex-n";
export var shipmentSummaryGrid = "_ex-m";
export var shipmentSummaryMetadataRow = "_ex-o";
export var shipmentSummaryTags = "_ex-p";
export var shipmentWorkspace = "_ex-0";
export var shipmentWorkspaceBodyTablet = "_ex-8";
export var shipmentWorkspaceContent = "_ex-b";
export var shipmentWorkspaceHeader = "_ex-1";